import { render, staticRenderFns } from "./funPresUtil.vue?vue&type=template&id=32bbb392"
import script from "./funPresUtil.vue?vue&type=script&lang=js"
export * from "./funPresUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports